var _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _path, _path2, _polygon, _polygon2, _polygon3, _g, _polygon4, _path3, _path4, _path5, _ellipse9, _ellipse10, _ellipse11, _ellipse12, _ellipse13, _ellipse14, _ellipse15, _ellipse16, _path6, _path7, _ellipse17, _ellipse18, _ellipse19, _ellipse20, _ellipse21, _ellipse22, _ellipse23, _ellipse24, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNewTour(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "e937dd5c-1a88-46eb-b274-68931cd56025",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 923.8,
    height: 753.71,
    viewBox: "0 0 923.8 753.71",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "map") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1007.29,
    cy: 789.73,
    rx: 19.99,
    ry: 48.53,
    transform: "translate(-401.49 870.42) rotate(-45)",
    fill: "#134db3",
    opacity: 0.1
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 872.63,
    cy: 705.7,
    rx: 10.73,
    ry: 14.05,
    fill: "#3f3d56"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 872.63,
    cy: 688.53,
    rx: 10.73,
    ry: 14.05,
    fill: "#3f3d56"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 872.63,
    cy: 671.36,
    rx: 10.73,
    ry: 14.05,
    fill: "#3f3d56"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 872.63,
    cy: 654.19,
    rx: 10.73,
    ry: 14.05,
    fill: "#3f3d56"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 872.63,
    cy: 637.02,
    rx: 10.73,
    ry: 14.05,
    fill: "#3f3d56"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 872.63,
    cy: 619.85,
    rx: 10.73,
    ry: 14.05,
    fill: "#3f3d56"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 872.63,
    cy: 602.68,
    rx: 10.73,
    ry: 14.05,
    fill: "#3f3d56"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1050.9,558.33a51.13,51.13,0,0,0,4-5.88l-28.2-4.63,30.5.22a51.54,51.54,0,0,0,1-40.73l-40.91,21.23L1055,500.8a51.41,51.41,0,1,0-84.9,57.53,51.16,51.16,0,0,0-5.86,9.37l36.6,19-39-13.1a51.45,51.45,0,0,0,8.29,48.27,51.4,51.4,0,1,0,80.8,0,51.41,51.41,0,0,0,0-63.56Z",
    transform: "translate(-138.1 -73.15)",
    fill: "#134db3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M959.1,590.11a51.16,51.16,0,0,0,11,31.78,51.4,51.4,0,1,0,80.8,0C1057.79,613.15,959.1,584.34,959.1,590.11Z",
    transform: "translate(-138.1 -73.15)",
    opacity: 0.1
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "846.97 0 846.97 720 602.97 686 306.36 746.51 303.97 747 67.97 682 67.97 56 312.97 0 580.97 56 591.16 53.85 846.97 0",
    fill: "#444053"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "805.97 39.32 805.97 683.53 587.66 653.11 322.27 707.25 320.13 707.68 108.97 649.53 108.97 89.42 328.19 39.32 567.97 89.42 577.09 87.5 805.97 39.32",
    fill: "#fff"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "602.97 686 306.36 746.51 312.97 0 580.97 56 591.16 53.85 602.97 686",
    opacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "573.35 138 573.47 347.5 660.47 347.5 660.47 261.5 809.47 261.5 826.97 239.06",
    fill: "none",
    stroke: "#444053",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "88.97 204.5 412.47 204.5 432.47 195.5 440.47 195.5 440.47 397.5 580.47 397.5 586.47 415.5 586.47 506.5 694.47 506.5 694.47 619",
    fill: "none",
    stroke: "#444053",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 483.2,
    y1: 619,
    x2: 483.2,
    y2: 397.5,
    fill: "none",
    stroke: "#444053",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 826.97,
    y1: 559.66,
    x2: 483.2,
    y2: 559.66,
    fill: "none",
    stroke: "#444053",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 740.87,
    y1: 138,
    x2: 740.87,
    y2: 619,
    fill: "none",
    stroke: "#444053",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 87.97,
    y1: 517.14,
    x2: 826.97,
    y2: 517.14,
    fill: "none",
    stroke: "#444053",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 177.91,
    y1: 619,
    x2: 177.91,
    y2: 138,
    fill: "none",
    stroke: "#444053",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 349.69,
    y1: 138,
    x2: 349.69,
    y2: 619,
    fill: "none",
    stroke: "#444053",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 88.97,
    y1: 259.5,
    x2: 660.47,
    y2: 261.5,
    fill: "none",
    stroke: "#444053",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 255.3,
    y1: 138.87,
    x2: 255.3,
    y2: 619,
    fill: "none",
    stroke: "#444053",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "87.97 370.82 349.69 370.82 483.2 517.14",
    fill: "none",
    stroke: "#444053",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 512.12,
    y1: 138,
    x2: 512.12,
    y2: 397.5,
    fill: "none",
    stroke: "#444053",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 483.2,
    y1: 443.98,
    x2: 826.97,
    y2: 443.98,
    fill: "none",
    stroke: "#444053",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }))), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "585.97 442 484.97 442 484.97 398 580.47 397.5 586.47 414.5 585.97 442",
    fill: "#134db3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M674.07,287.15a55.28,55.28,0,0,0-55.28,55.28c0,30.53,55.28,129.72,55.28,129.72S729.35,373,729.35,342.43A55.28,55.28,0,0,0,674.07,287.15Zm0,78.86a24.32,24.32,0,1,1,24.32-24.32A24.32,24.32,0,0,1,674.07,366Z",
    transform: "translate(-138.1 -73.15)",
    fill: "#134db3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M674.07,287.15a55.28,55.28,0,0,0-55.28,55.28c0,30.53,55.28,129.72,55.28,129.72S729.35,373,729.35,342.43A55.28,55.28,0,0,0,674.07,287.15Zm0,78.86a24.32,24.32,0,1,1,24.32-24.32A24.32,24.32,0,0,1,674.07,366Z",
    transform: "translate(-138.1 -73.15)",
    opacity: 0.1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M674.07,295.15a55.28,55.28,0,0,0-55.28,55.28c0,30.53,55.28,129.72,55.28,129.72S729.35,381,729.35,350.43A55.28,55.28,0,0,0,674.07,295.15Zm0,78.86a24.32,24.32,0,1,1,24.32-24.32A24.32,24.32,0,0,1,674.07,374Z",
    transform: "translate(-138.1 -73.15)",
    fill: "#134db3"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 649.86,
    cy: 806.61,
    rx: 33.45,
    ry: 13.78,
    transform: "translate(-404.13 249.64) rotate(-23.3)",
    fill: "#134db3",
    opacity: 0.1
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 511.39,
    cy: 727.97,
    rx: 7.4,
    ry: 9.68,
    fill: "#3f3d56"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 511.39,
    cy: 716.13,
    rx: 7.4,
    ry: 9.68,
    fill: "#3f3d56"
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 511.39,
    cy: 704.3,
    rx: 7.4,
    ry: 9.68,
    fill: "#3f3d56"
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 511.39,
    cy: 692.47,
    rx: 7.4,
    ry: 9.68,
    fill: "#3f3d56"
  })), _ellipse14 || (_ellipse14 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 511.39,
    cy: 680.63,
    rx: 7.4,
    ry: 9.68,
    fill: "#3f3d56"
  })), _ellipse15 || (_ellipse15 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 511.39,
    cy: 668.8,
    rx: 7.4,
    ry: 9.68,
    fill: "#3f3d56"
  })), _ellipse16 || (_ellipse16 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 511.39,
    cy: 656.97,
    rx: 7.4,
    ry: 9.68,
    fill: "#3f3d56"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M621.8,649.13a36.12,36.12,0,0,1-2.76-4l19.44-3.2-21,.16a35.54,35.54,0,0,1-.68-28.07L645,628.6l-26-19.12a35.43,35.43,0,1,1,58.51,39.65,35.55,35.55,0,0,1,4,6.46L656.3,668.7l26.9-9a35.45,35.45,0,0,1-5.71,33.27,35.43,35.43,0,1,1-55.69,0,35.44,35.44,0,0,1,0-43.81Z",
    transform: "translate(-138.1 -73.15)",
    fill: "#134db3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M685.07,671a35.28,35.28,0,0,1-7.58,21.91,35.43,35.43,0,1,1-55.69,0C617.05,686.91,685.07,667.06,685.07,671Z",
    transform: "translate(-138.1 -73.15)",
    opacity: 0.1
  })), _ellipse17 || (_ellipse17 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 186.29,
    cy: 767.73,
    rx: 19.99,
    ry: 48.53,
    transform: "translate(-626.4 283.44) rotate(-45)",
    fill: "#134db3",
    opacity: 0.1
  })), _ellipse18 || (_ellipse18 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 51.63,
    cy: 683.7,
    rx: 10.73,
    ry: 14.05,
    fill: "#3f3d56"
  })), _ellipse19 || (_ellipse19 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 51.63,
    cy: 666.53,
    rx: 10.73,
    ry: 14.05,
    fill: "#3f3d56"
  })), _ellipse20 || (_ellipse20 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 51.63,
    cy: 649.36,
    rx: 10.73,
    ry: 14.05,
    fill: "#3f3d56"
  })), _ellipse21 || (_ellipse21 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 51.63,
    cy: 632.19,
    rx: 10.73,
    ry: 14.05,
    fill: "#3f3d56"
  })), _ellipse22 || (_ellipse22 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 51.63,
    cy: 615.02,
    rx: 10.73,
    ry: 14.05,
    fill: "#3f3d56"
  })), _ellipse23 || (_ellipse23 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 51.63,
    cy: 597.85,
    rx: 10.73,
    ry: 14.05,
    fill: "#3f3d56"
  })), _ellipse24 || (_ellipse24 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 51.63,
    cy: 580.68,
    rx: 10.73,
    ry: 14.05,
    fill: "#3f3d56"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M229.9,536.33a51.13,51.13,0,0,0,4-5.88l-28.2-4.63,30.5.22a51.54,51.54,0,0,0,1-40.73l-40.91,21.23L234,478.8a51.41,51.41,0,1,0-84.9,57.53,51.16,51.16,0,0,0-5.86,9.37l36.6,19-39-13.1a51.45,51.45,0,0,0,8.29,48.27,51.4,51.4,0,1,0,80.8,0,51.41,51.41,0,0,0,0-63.56Z",
    transform: "translate(-138.1 -73.15)",
    fill: "#134db3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M138.1,568.11a51.16,51.16,0,0,0,11,31.78,51.4,51.4,0,1,0,80.8,0C236.79,591.15,138.1,562.34,138.1,568.11Z",
    transform: "translate(-138.1 -73.15)",
    opacity: 0.1
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewTour);
export default __webpack_public_path__ + "static/media/new-tour.37a827f931bdecca74fb7aec41720f79.svg";
export { ForwardRef as ReactComponent };